(ns minorodata.components.connections.extract-table-details
  (:require
   [minorodata.app.handlers :refer [dispatch]]
   [minorodata.components.spinner.core :refer [spinner-lucide]]
   [minorodata.components.tables.core :refer [init-tables]]
   [minorodata.components.tables.details :refer [->qualified-name preview-in-console]]
   [minorodata.sql-console.api :as sql-console.api]
   [re-posh.core :as re-posh]
   [react :as react]
   [ui.button :refer [button]]
   [ui.date-time :refer [date-tooltip]]
   [ui.table :as table]
   [ui.typography :as typography]))

(defn table-details [{:keys [params on-close]}]
  (let [{:keys [catalog schema table]} params
        fetch-params {:object  "columns"
                      :catalog catalog
                      :schema  schema
                      :table   table}
        columns      @(re-posh/subscribe [:sql-metadata-partial/prop
                                          [:sql-metadata-partial/params fetch-params]
                                          :sql-metadata-partial/metadata])
        table-data   @(re-posh/subscribe [:tables-metadata.subs/table params])
        columns-loading? @(re-posh/subscribe [:mold-http/loading-id? :sql-console.api/fetch-metadata
                                              (sql-console.api/->metadata-request-id fetch-params)])
        table-loading?   @(re-posh/subscribe [:mold-http/loading? :tables.api/fetch-tables])
        table-loaded?    (some? table-data)
        timezone     @(re-posh/subscribe [:app.subs/timezone])
        warehouse-type @(re-posh/subscribe [:warehouse-data/prop :warehouse-data/sink-type])
        snowflake?     (= warehouse-type "snowflake")
        {:keys [created row-count unit-tests]} table-data]

    (react/useEffect
     (fn []
       (dispatch [:sql-console.api/fetch-metadata fetch-params])
       (when-not table-loaded?
         (init-tables))
       (fn []))
     #js [catalog schema table])

    [:div {:class "max-w-[860px] space-y-6"}
     [:div {:class "flex gap-2"}
      [button {:variant  :empty
               :disabled (or columns-loading? (empty? columns))
               :on-click (fn []
                           (preview-in-console catalog schema table columns)
                           (when on-close (on-close)))}
       "SQL Console"]

      (when snowflake?
        [button {:variant  :empty
                 :on-click #(dispatch
                             [:app.events/navigate-query
                              {:json-flattening true
                               :table-name      (->qualified-name catalog schema table)}])}
         "SQL Generator"])]
     [:section
      [typography/h3 "Details"]
      [:ul {:class "mt-2 space-y-1 text-kleene-text-secondary"}
       [:li "Table: " [:span {:class "text-kleene-text"} catalog "." schema "." table]]
       [:li "Created: "
        (cond
          created [date-tooltip {:date created :timezone timezone}]
          (or table-loading? (not table-loaded?)) "Loading..."
          :else "No data")]
       [:li "Row count: "
        (cond
          row-count row-count
          (or table-loading? (not table-loaded?)) "Loading..."
          :else "No data")]]]

     [:section
      [typography/h3 "Columns"]

      (cond
        columns-loading?
        [:div {:class "mt-4 flex items-center gap-2"}
         [spinner-lucide]
         "Loading..."]

        (seq columns)
        [:div {:class "mt-4 overflow-hidden rounded-xs border"}
         [table/table {:style {"--background" "transparent"}
                       :class "text-sm"}
          [table/thead
           [table/tr
            [table/th "Column"]
            [table/th "Type"]]]
          [table/tbody
           (for [{:keys [column-name type-name]} columns]
             ^{:key column-name}
             [table/tr
              [table/td column-name]
              [table/td type-name]])]]]

        :else
        [typography/p {:class "mt-2 text-kleene-text-secondary"}
         "No data"])]

     [:section
      [typography/h3 "Unit test results"]

      (if (seq unit-tests)
        (let [headers (keys (first unit-tests))]
          [:div {:class "mt-4 overflow-hidden rounded-xs border"}
           [table/table {:style {"--background" "transparent"}
                         :class "text-sm"}
            [table/thead
             [table/tr
              (for [header headers]
                ^{:key header}
                [table/th (name header)])]]
            [table/tbody
             (for [[idx row] (map-indexed vector unit-tests)]
               ^{:key idx}
               [table/tr
                (for [header headers]
                  ^{:key header}
                  [table/td (get row header)])])]]])
        [typography/p {:class "mt-2 text-kleene-text-secondary"}
         "No data"])]]))
